/*global Materialize*/
/*eslint no-undef: ["error", { "typeof": true }] */

import React, { Component }   from 'react';
import { connect }            from 'react-redux';
import validator              from 'validator';
import {fetch}                from '@fyresite/fetch';
import { permissions } from '../../../constants.js';
import TextInput       from '@fyresite/react-textinput';
import Button          from '../../../components/Button'

class EditUser extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      user: {},
      email: {
        value: '',
        valid: '',
        error: "Please give a valid Email Address"
      },
      firstName: {
        value: '',
        valid: '',
        error: "Please provide a First Name"
      },
      lastName: {
        value: '',
        valid: '',
        error: "Please provide a Last Name"
      },
      permissions: {
        value: '',
        valid: '',
        error: "Please add Permissions"
      },
      password: {
        value: '',
        valid: '',
      },
      password_confirm: {
        value: '',
        valid: ''
      }
    };
    this.handleInputKeyPress = this.handleInputKeyPress.bind(this)
  }


  componentWillUnmount(){
    document.removeEventListener("keydown", this.handleInputKeyPress);
  }
  componentWillMount(){

    this.getUser();
    document.addEventListener("keydown", this.handleInputKeyPress);
  }
  handleInputKeyPress(e){
    if(e.key.toLowerCase() === 'enter'){
      this.handleSubmit(e);
    }
  }

  getUser(){
    fetch(`/api/v1/user/read/${this.props.match.params.id}`, {
      method: 'GET',
      headers: { "Content-Type": "application/json" },
    }).then(res => {
      return res.json();
    }).then(json => {
      if(json.code === 200){
        let state = JSON.parse(JSON.stringify(this.state));
        state.user = json.result.user;

        for(var x = 0; x < Object.keys(state).length; x++){
          let key = Object.keys(state)[x];

          if(json.result.user[key]){
            state[key].value = json.result.user[key]
            state[key].valid = true;
          }
        }

        this.setState((prevState, props) => {
          return state
        });

      } else{
        Materialize.toast(`Error occured, ${json.message}`, 4000, 'red');
      }
    }).catch(err => {
      Materialize.toast(`Fetch error, ${err}`, 4000, 'red');
    })
  }



  handleSubmit(e) {
    e.preventDefault();
    let updateValues = {};
    let state = JSON.parse(JSON.stringify(this.state));
    delete state.password;
    delete state.password_confirm;
    delete state.user;

    Object.keys(state).forEach(key => {
      if(state[key].valid){
        updateValues[key] = state[key].value;
      } else {
        Materialize.toast(`${state[key].error}`, 4000, 'red');
        return;
      }
    })

    if(this.state.password.value.length > 1){
      if(this.state.password.valid && this.state.password_confirm.valid){
        updateValues.password = this.state.password.value;
      } else if(!this.state.password.valid) {
        Materialize.toast("Password field invalid", 4000, 'red');
        return;
      } else if(!this.state.password_confirm.valid){
        Materialize.toast("Confirm password does not equal the password field", 4000, 'red');
        return;
      }
    }

    fetch(`/api/v1/user/update/${this.state.user.id}`, {
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updateValues)
    }).then(res => {
      return res.json();
    }).then(json => {
      if(json.code === 200){
        Materialize.toast("User was updated", 4000);
      } else {
        Materialize.toast(`Error Occured, ${json.message}`, 4000, 'red');
      }
    }).catch(err => {
      Materialize.toast(`Fetch error, ${err}`, 4000)
    })
  }

  onChange(field, e, inputState) {
    let state = Object.assign({}, this.state);

		state[field] = Object.assign({}, state[field], inputState);

    this.setState((prevState, props) => {
      return state;
    });
  }

  onRadioChange(field, e){
    let value = e.target.value;
    let stateField = this.state[field];

    stateField.value = value;
    stateField.valid = true;

    this.setState((prevState, props) => {
      return {
        [field]: stateField
      }
    })
  }

  render() {

    return (
      <div className="edit-user">
        <div className="edit-user-inner">
          <h4>Edit User</h4>
          <div className="card-container card-wrapper">
            <div className="form-card card z-depth-5" ref="form-card">
              <div className="card-content">
                <span className="card-title">{this.props.title}</span>
                <form onSubmit={this.handleSubmit.bind(this)} className="left-align" noValidate>
                  <TextInput
                    ref={input => this.email = input}
                    className=""
                    inputClassName=""
                    id='email'
                    disabled={true}
                    label='Email Address'
                    error='Please enter a valid email address'
                    type='email'
                    onChange={this.onChange.bind(this, "email")}
                    value={this.state.email.value}
                    valid={this.state.email.valid}
                    validator={val => { return validator.isEmail(val) }} />
                  <TextInput
                    ref={input => this.firstName = input}
                    className=""
                    inputClassName=""
                    id='firstName'
                    label='First Name'
                    error='Please enter a first name'
                    type='text'
                    onChange={this.onChange.bind(this, "firstName")}
                    value={this.state.firstName.value}
                    valid={this.state.firstName.valid}
                    validator={val => { return val.length > 1 }} />
                  <TextInput
                    ref={input => this.lastName = input}
                    className=""
                    inputClassName=""
                    id='lastName'
                    label='Last Name'
                    error='Please enter a last name'
                    type='text'
                    onChange={this.onChange.bind(this, "lastName")}
                    valid={this.state.lastName.valid}
                    value={this.state.lastName.value}
                    validator={val => { return val.length > 1 }} />
                  <div>
                    <p>{"Permissions"}</p>
                    <div className="radios">
                      {
                        Object.keys(permissions).map((key,index) => {
                          let value = permissions[key];

                          return (
                            <div key={`${value}-${index}`}>
                              <input
                                type="radio"
                                id={`permissions-${value}`}
                                disabled={this.props.user.id === this.state.user.id}
                                checked={parseInt(value,10) === parseInt(this.state.permissions.value, 10)}
                                value={value}
                                onChange={this.onRadioChange.bind(this, "permissions")} />
                              <label htmlFor={`permissions-${value}`}>{key}</label>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                  <TextInput
                    ref={input => this.password = input}
                    className=""
                    inputClassName=""
                    label="Password"
                    type="password"
                    onChange={this.onChange.bind(this, 'password')}
                    value={this.state.password.value}
                    valid={this.state.password.valid}
                    validator={val => { return validator.matches(val, /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{4,15}$/) }}
                    error="Password must be at least 4 characters, no more than 15 characters, and must include at least one upper case letter, one lower case letter, and one numeric digit." />
                  <TextInput
                    ref={input => this.password_confirm = input}
                    className=""
                    inputClassName=""
                    label="Confirm Password"
                    type="password"
                    onChange={this.onChange.bind(this, 'password_confirm')}
                    value={this.state.password_confirm.value}
                    valid={this.state.password_confirm.valid}
                    validator={val => { return val === this.state.password.value }}
                    error="Must match the password field" />
                  <Button
                    color={'red'}
                    flat={false}
                    onClick={this.handleSubmit.bind(this)}
                    z-depth={1}>
                    {"Update User"}
                  </Button>
                  <Button
                    color={null}
                    flat={true}
                    onClick={e => this.props.history.push('/dashboard/list-users')}
                    z-depth={1}>
                    {"Back"}
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps)(EditUser);



// WEBPACK FOOTER //
// ./src/pages/Dashboard/EditUser/EditUser.js